var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PromotionHeader',{attrs:{"img_header":_vm.header_image,"header":"ตั้งกลุ่มสินค้าคละใหม่","link_back":"stock/promotion_stock/promotionassorted"}}),_c('Promotion_add_group')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }